<template>
  <div class="header">
    <div class="header__user">
      <div class="header__user--name">
        <span>{{ getAdminId }}</span
        ><span>님</span>
      </div>
      <div class="header__logout" @click="logoutPopup = true">
        <font-awesome-icon icon="fa-solid fa-arrow-right-from-bracket" />
        Log Out
      </div>
    </div>
    <popup-modal
      :logoutType="true"
      v-if="logoutPopup"
      @open-click="logoutPopup = false"
      @button-click="adminLogout()"
    ></popup-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { deleteCookies } from '@/utils/cookie'
import PopupModal from '@/components/PopupModal.vue'
export default {
  name: 'WebHeader',
  components: {
    PopupModal,
  },
  data() {
    return {
      logoutPopup: false,
    }
  },
  computed: {
    ...mapState('adminUser', { data: 'maintaince' }),
    getAdminId() {
      return this.data.adminId
    },
  },
  methods: {
    ...mapMutations('adminUser', ['INIT_DATA']),
    ...mapActions('adminUser', ['LOGOUT']),
    async adminLogout() {
      try {
        await this.LOGOUT().then((data) => {
          if (data.message && data.message === 'success') {
            deleteCookies()
            // console.log('로그아웃 성공')
            this.INIT_DATA()
            this.$router.push('/')
          }
        })
      } catch (e) {
        console.error(e)
        deleteCookies()
        this.INIT_DATA()
        this.$router.push('/')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  //width: calc(100% - 250px);
  height: 60px;
  &__user {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    width: 100%;
    padding: 0 40px;
    background: #fff;
    border-bottom: 1.5px solid #1f3d6825;
    // box-shadow: 9px -2px 8px 4px #d7d7d7;
    color: #2f2f2f;

    &--name {
      font-weight: 600;
      span + span {
        margin-left: 5px;
      }
    }
  }
  &__logout {
    cursor: pointer;
  }
}
</style>
